import React, { Component } from 'react'
import Layout from './components/Layout.component'

import { connect } from 'react-redux'
import { checkLoggedin, getAvatar } from './actions/users'
import util from './helpers/util.helper'

class App extends Component {
  state = {
    isLoggedIn: false
  }

  componentDidMount () {
    const { pathname } = this.props.location
    if (pathname !== '/error') {
      this.props.checkLoggedin().then(() => {
        if (this.props.self.user.is_force_reset_password) {
          window.location.href = util.forwardClientQueryStringToPath('/password/update', this.props.location.search)
          return
        }
        this.setState({ isLoggedIn: true, user: this.props.self.user })
      }, err => {
        this.setState({ isLoggedIn: false })
        window.location.href = '/login'
        console.error(err)
      })
    }
  }

  render () {
    const { isLoggedIn, user } = this.state

    return (
      <>
        {
          isLoggedIn && <Layout user={user} getAvatar={getAvatar} />
        }
      </>
    )
  }
}

function mapStateToProps (state) {
  return {
    self: state.self
  }
}

export default connect(mapStateToProps, { checkLoggedin, getAvatar })(App)
